import React, { Component } from 'react';
import { Link, NavLink } from "react-router-dom";
import * as ROUTES from '../../constants/routes';
import styled from "styled-components";
import * as MDICONS from '@material-ui/icons';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import EmptyUserDefault from '../../assets/mics/emptyUser.svg';
import Loader from 'react-loader-spinner';
import { connect } from 'react-redux';
import NotificationDrawer from '../notifications/NotificationDrawer';
import { get } from 'lodash'
import ProjectDrawer from '../project/ProjectDrawer'
import { signOut } from '../../store/actions/authActions';
import PlaceholderImage from '../widgets/PlaceholderImage';
const StyledButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: rgba(4,9,38,0.7);
        background-color: rgba(4,9,38,0.7);

        &:hover {
            background-color: rgba(4,9,38,1);
        }

        &:active {
            background-color: rgba(4,9,38,1);
        }
    }
`;



class SignedInLinks extends Component {

    constructor(props) {
        super()
        this.state = {
            projectSearchName: "",

        }
    }
    /// README: TO BE SEARCH ENTRY
    handleSearch = (e) => {
        this.setState({
            projectSearchName: e.target.value
        });
    }

    /// README: SEARCH STRING VALIDITY CHECK
    //      (return true if "" and " " is not entered as first character)
    checkValidSearch = () => {
        const { projectNameForSearch } = this.state;
        return (projectNameForSearch === "" || projectNameForSearch.startsWith(" ")) === false;
    }
    /// README: FILTERS THE accessMap BY SEARCH STRING
    filterBySearch = (s) => {
        const { projectNameForSearch } = this.state;
        var sprojectTitle = `${s.projectTitle}`;
        return sprojectTitle.toLowerCase().startsWith(projectNameForSearch.toLowerCase());
    }
    handleSignOut = (e) => {
        e.preventDefault();
        this.props.signOut();
    }
    render() {
        const { userData, companyData, alu, themeColors, companyDataNotification, companyNotificationsMeta } = this.props;
        // console.log(companyDataNotification,companyNotificationsMeta)
        const { totalNotifications, totalNotificationsRead } = companyNotificationsMeta ? companyNotificationsMeta : { "totalNotifications": 0, "totalNotificationsRead": 0 };
        var totalUnreadNotifications = (totalNotifications ? totalNotifications : 0) - (totalNotificationsRead ? totalNotificationsRead : 0);

        // if (totalUnreadNotifications > 0) {
        //     const audio = new Audio("https://firebasestorage.googleapis.com/v0/b/snaggingapp-72f9c.appspot.com/o/SI-templates%2Fstatic%2Ftones%2Fjuntos-607.mp3?alt=media&token=cedff358-d1ce-48aa-8e8f-049e7e26bb1f");
        //     audio.load();
        //     audio.autoplay = true;
        // }

        var notificationIndicator = Number.isNaN(totalUnreadNotifications) || totalUnreadNotifications <= 0 ? <React.Fragment /> : <span role="img" aria-label="">🔴</span>;

        const { isCompanyInsider } = alu;
        var relevantCompanyDashboard = <React.Fragment />
        // var relevantCompanyVisibility = <React.Fragment/>
        var relevantPricingText = "Register a new company"
        if (companyData) {
            const { accessMap } = companyData;
            const ueid = userData.uid + userData.employeeid;
            var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
            relevantCompanyDashboard = isCompanyInsider[accessLevel] ? <p><NavLink to={ROUTES.HOME_COMPANY} className="mx-2" style={{ color: 'black' }}><span style={{ marginRight: '0px', fontSize: '12px' }}>{notificationIndicator}</span>Company dashboard</NavLink></p> : <React.Fragment />
            relevantPricingText = isCompanyInsider[accessLevel] ? "Change or upgrade your plan" : "Register a new company"
            // relevantCompanyVisibility = isCompanyInsider[accessLevel]?<p><NavLink to={ROUTES.HOME_COMPANY} className="mx-2" style={{ color: 'black' }}>Company dashboard</NavLink></p> : <React.Fragment />;
        }

        const relevantAvatar = <div style={{ display: 'inline', width: '20px', height: '20px' }}><PlaceholderImage text={userData.uid} /></div>

        const avatar = userData ?
            (
                <React.Fragment>
                    {/* <NavLink to="#!" href="https://assettag.stradaimaging.com" target="_blank" className="mx-2">Docs</NavLink> */}
                    {/* <NavLink to={ROUTES.CONTACT} className="mx-2">Help</NavLink> */}
                    <span className="dropdown">
                        <button type="button" className="btn btn-sm btn-flat" id="menu" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
                            <span className="" style={{ textAlign: 'start' }}>
                                {relevantAvatar}
                            </span>

                            {/* {iconToDisplay} */}
                            {/* <PlaceholderImage text={companyData.name} /> */}
                            <span className="pl-4" style={{ color: themeColors.backgroundColor, fontSize: '16px' }}>{userData.name}</span>
                            <sup style={{ marginLeft: '5px' }}>{notificationIndicator}</sup>
                        </button>
                        <div className="dropdown-menu dropdown-menu-lg-right p-4" aria-label="menu" style={{ width: "20rem", maxHeight: "380px", overflowY: "auto" }}>
                            <button className="btn btn-flat">
                                <div className="text-left" style={{ fontSize: '18px' }}><b>{userData.name}</b></div>
                                <div className="text-left" style={{ fontSize: '14px' }}>{userData.email}</div>
                            </button>
                            <hr />
                            <div className="px-2">
                                {relevantCompanyDashboard}
                                <p><NavLink to={ROUTES.PRICING} className="mx-2" style={{ color: 'black' }}>{relevantPricingText}</NavLink></p>
                                <p><NavLink to={ROUTES.CONTACT} className="mx-2" style={{ color: 'black' }}>Need help?</NavLink></p>
                            </div>
                            <hr />
                            <button className="btn btn-flat" onClick={this.handleSignOut}><span style={{ color: 'darkred' }}><b>Sign out</b></span></button>
                        </div>
                    </span>
                    {/* <NavLink to={ROUTES.USER_PROFILE} className="mx-2">
                        <img src={userData.profilePic === "" ? EmptyUserDefault : userData.profilePic} alt="user" className="avatar" />
                    </NavLink> */}
                </React.Fragment>
            ) : (
                <Loader
                    type="TailSpin"
                    color={this.props.themeColors.themeColor}
                    height={30}
                    width={30}
                />
            )
        return (
            <div className="collapse navbar-collapse" id="navbarText">
                <NavLink to={ROUTES.HOME_PROJECTS} className="mx-2" style={{ color: 'white' }}>Home</NavLink>
                <div className="vl-topbar" />
                <ul className="navbar-nav mr-auto center">
                    <li className="nav-item active">
                        <ProjectDrawer />
                    </li>
                </ul>
                {/* Notification Button and Drawer */}
                <NotificationDrawer />
                <div className="vl-topbar" />
                <span className="navbar-text pr-3">
                    {avatar}
                </span>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        userId: state.firebase.auth.uid,
        userData: state.firebase.profile,
        userDataNotification: state.firestore.ordered.Notifications,
        allProjects: state.firestore.ordered.Projects,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        auth: state.firebase.auth,
        companyData: state.firestore.data.Company,
        alu: state.alu,
        companyDataNotification: state.firestore.ordered.CompanyNotifications,
        companyNotificationsMeta: get(state.firebase.data, `CompaniesMeta.${state.firebase.profile.coid}.Notifications`),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        signOut: () => dispatch(signOut()),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => {
        var ueid = props.auth.uid + props.userData.employeeid;
        var coid = props.userData.coid;
        if (coid === "-1") {
            return [
                {
                    collection: 'Projects',
                    where: [['accessList', 'array-contains', `${ueid}`]],
                    orderBy: [['dateCreated', 'desc']],
                }
            ]
        } else {
            return [
                {
                    collection: 'Projects',
                    where: [['accessList', 'array-contains', `${ueid}`], ['coid', '==', `${coid}`]],
                    orderBy: [['dateCreated', 'desc']],
                }
            ]
        }
    })
)


    (SignedInLinks)
